module.exports = __webpack_public_path__ + "static/media/guy_with_cash.047b4242.svg";